import { createSelector } from 'reselect';
import { whatIfsOrDefaultSelector } from '../WhatIfsSelector';

export const errorsSelector = createSelector(
  whatIfsOrDefaultSelector,
  whatIfs => whatIfs.errors,
);

export const hasErrorsSelector = createSelector(
  errorsSelector,
  errors => errors.length > 0,
);
